// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'

// This component displays errors as they are presented from the API's custom validator

const bb = {
  borderBottom: '2px solid',
}

const ErrorsList = props => {
  const {
    errors,
    idRoot,
    message,
  } = props

  if (!message && !errors) {
    return null
  }

  return (
    <div className={'errors-list-wrapper text-red padding-1'}>
      {
        message &&
        <h1
          id={`${idRoot}-error`}
          style={bb}>
          {message}
        </h1>
      }
      {
        errors &&
        errors.map((d, i) => (
          <dl
            key={i}
            className={'error-list-messages padding-top-1'}>
            <dt
              className={'error-list-header'}
              id={`${idRoot}-error-list-${i}-header`}>
              {
                // NOTE - if this error object comes from Spring Validation, it will have defaultMessage and no header.
                d.header
                  ? d.header + ' :'
                  : d.defaultMessage
              }
            </dt>
            {
              // NOTE - if this error object comes from Spring Validation, it will not have a messages array.
              d.messages && d.messages.map((dd, ii) => (
                <dd
                  key={ii}
                  id={`${idRoot}-error-list-${i}-message-${ii}`}
                  className={'padding-left-half'}>
                  {'- ' + dd}
                </dd>
              ))
            }
          </dl>
        ))
      }
    </div>
  )
}

ErrorsList.propTypes = {
  errors: array,
  idRoot: string.isRequired,
  message: string,
}

export default ErrorsList
